import { render, staticRenderFns } from "./NmsSettings.vue?vue&type=template&id=0d3606de&"
import script from "./NmsSettings.vue?vue&type=script&lang=js&"
export * from "./NmsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports